import axios from 'axios'
import keycloak from '../Components/keycloak'
// const JWTtoken = sessionStorage.getItem('jwt')
// console.log('keycloak.token::', keycloak.token)
// Use content type as form for file upload scenarios
const headers = {
    'Authorization': `Bearer ${keycloak.token}`,
    'Content-Type': 'application/json'
}

const determineURL = () => {
    const location = window.location.hostname
    const baseUrl = `https://${location}/api/bcrms`
    if (location === 'localhost') {
        return 'http://localhost:5519'
    }

    return baseUrl
}

export default axios.create({
    baseURL: determineURL(),
    responseType: "json",
    headers
})